import { Component, OnInit } from '@angular/core';
import { FormService } from '../form.service';

declare let $:any;

@Component({
  selector: 'hc-screen-finish',
  templateUrl: './screen-finish.component.html'
})
export class ScreenFinishComponent implements OnInit {

  constructor(
    private form : FormService
  ) { }

  /* Update wrapper height */
  ngOnInit() {
    $('.survey-wrapper').height($('.screen').outerHeight());
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/screen-finish/screen-finish.component.ts